import { formatDate } from '@angular/common';
import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HealthGuidelineTriageData, UtilsClassificationService } from 'src/app/classification/utils.service';
import { ValidateFutureDate } from 'src/app/shared/custom-validators/date.validator';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { Masks, MaskService } from 'src/app/shared/services/mask.service';
import { HealthGuidelineCategorization } from 'src/app/shared/services/models/risk-classification/health-guideline-categorization.model';
import { HealthGuideline } from 'src/app/shared/services/models/risk-classification/health-guideline.model';

@Component({
  selector: 'app-health-guideline-triage-modal',
  templateUrl: './health-guideline-triage-modal.component.html',
  styleUrls: ['./health-guideline-triage-modal.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class HealthGuidelineTriageModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<HealthGuidelineTriageModalComponent>,
    private formBuilder: FormBuilder,
    private maskService: MaskService,
    private utilClassificationService: UtilsClassificationService,
    private alertService: AlertService
  ) { }

  public listCategorization: HealthGuidelineCategorization[] = [];
  public selectedCategorizations: HealthGuidelineCategorization[] = []; // Alterado para Array
  public healthGuideline: HealthGuideline;
  public model: FormGroup;
  public masks: Masks = this.maskService.getMasks();
  public isMultipleSelection: boolean = false; // Flag para controle de múltipla seleção

  ngOnInit(): void {
    console.log(this.data);
    this.listCategorization = this.data.healthGuidelineStruct.listHealthGuidelineCategorization;
    this.healthGuideline = this.data.healthGuidelineStruct.healthGuideline;

    // Captura se o protocolo permite múltipla seleção
    this.isMultipleSelection = this.healthGuideline.isMultipleSelection || false;

    this.model = this.formBuilder.group({
      symptomStartTime: ['', [Validators.required]],
      symptomStartDate: ['', [Validators.required, ValidateFutureDate()]],
    });
  }

  toggleCategorization(item: any) {
    if (this.isMultipleSelection) {
      const index = this.selectedCategorizations.findIndex(
        c => c.idHealthGuidelineCategorization === item.idHealthGuidelineCategorization
      );
      if (index > -1) {
        this.selectedCategorizations.splice(index, 1);
      } else {
        this.selectedCategorizations.push(item);
      }
    } else {
      // Seleção única: toggle — se já está selecionado, desmarca
      const alreadySelected = this.isSelected(item);
      this.selectedCategorizations = alreadySelected ? [] : [item];
    }

    if (item.useDatetimeEpisode && this.data.datetimeEpisode) {
      this.model.get('symptomStartDate')?.setValue(formatDate(this.data.datetimeEpisode, 'ddMMyyyy', 'pt-BR'));
      this.model.get('symptomStartTime')?.setValue(formatDate(this.data.datetimeEpisode, 'HHmm', 'en-US'));
    }
  }

  isSelected(item: HealthGuidelineCategorization): boolean {
    return this.selectedCategorizations.some(c => c.idHealthGuidelineCategorization === item.idHealthGuidelineCategorization);
  }

  submit() {
    if (this.selectedCategorizations.length === 0) {
      this.alertService.show('Aviso', "É necessário selecionar pelo menos uma categorização", AlertType.warning);
      return;
    }

    if (this.model.invalid)
      return;

    let timeString = this.model.get('symptomStartTime')?.value;
    let dateString = this.model.get('symptomStartDate')?.value;
    let formattedDate = this.formatDate(dateString, timeString);

    let triageDataList: HealthGuidelineTriageData[] = [];

    this.selectedCategorizations.forEach(categorization => {
      let triageData = new HealthGuidelineTriageData();
      triageData.healthGuideline = this.healthGuideline;
      triageData.healthGuidelineCategorization = categorization;
      triageData.datetimeStartSymptom = formattedDate;

      triageDataList.push(triageData);
    });

    this.utilClassificationService.createHealthGuidelineTriageData(triageDataList);

    this.matDialogRef.close();
  }

  back() {
    this.matDialogRef.close({ isReturn: true });
  }

  formatDate(dateString: string, timeString: string): Date {
    let darr = dateString.split("");
    let selectedDate = new Date(parseInt(darr[4] + darr[5] + darr[6] + darr[7]), parseInt(darr[2] + darr[3]) - 1, parseInt(darr[0] + darr[1]));
    let tarr = timeString.split("");
    let hour = parseInt(tarr[0] + tarr[1]);
    let minutes = parseInt(tarr[2] + tarr[3]);
    selectedDate.setHours(hour, minutes);
    return selectedDate;
  }
}